import { render } from "./CoreContentSection.vue?vue&type=template&id=5782c5a6&scoped=true"
import script from "./CoreContentSection.vue?vue&type=script&lang=js"
export * from "./CoreContentSection.vue?vue&type=script&lang=js"

import "./CoreContentSection.vue?vue&type=style&index=0&id=5782c5a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5782c5a6"]])

export default __exports__